<template>
  <b-card>
    <title-name />
    <title-en />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/Units/elements/Title.vue'
import TitleEn from '@/views/Admin/Defines/Units/elements/TitleEn.vue'

export default {
  name: 'UnitForm',
  components: {
    TitleEn,
    BCard,
    TitleName,
  },
}
</script>
